// extracted by mini-css-extract-plugin
export default {"root":"IconCircleTick_root__Uv8WS"};